import httpClient from './httpClient';

const PostRequestOTP = req => httpClient.post('/PostRequestOTP', req);
const PostCheckOTPMatch = req => httpClient.post('/PostCheckOTPMatch', req);

export default {
    PostRequestOTP,
    PostCheckOTPMatch
}; 